import { PayloadGroupMockup } from '../../../../../../../components/Forms/constants';
import { fieldNamesForServerFactory } from '../../../../../../../helpers/fieldNamesForServerFactory';

import { DeclaredAddressNewFieldName } from './types';

const payloadGroupName = 'declared_address_new';

export const declaredAddressNewDataPayloadGroupMockup: PayloadGroupMockup<typeof payloadGroupName> = {
  [payloadGroupName]: {
    country_id: null,
    country_name: null,
    region_id: null,
    region_name: null,
    district_id: null,
    district_name: null,
    settlement_id: null,
    settlement_name: null,
    street_id: null,
    street_name: null,
    house: null,
    building: null,
    apartment: null,
  },
};

export const declaredAddressNewDataFieldNamesForServer = fieldNamesForServerFactory({
  groupName: payloadGroupName,
  fields: [
    {
      localFieldName: DeclaredAddressNewFieldName.declaredAddressNew,
      serverFieldName: 'declaredAddressNew',
    },
    {
      localFieldName: DeclaredAddressNewFieldName.issuedResidence,
      serverFieldName: 'issued_residence',
    },
    {
      localFieldName: DeclaredAddressNewFieldName.expiredResidence,
      serverFieldName: 'expired_residence',
    },
  ],
});
